var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-tags py-2"},_vm._l((_vm.tags(_vm.message)),function(tag){return _c('message-tag',{key:tag.id,attrs:{"message":_vm.message,"tag":tag},on:{"onTagClick":_vm.tagClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }